import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './JobPreference.css';
import { useNavigate, useLocation } from 'react-router-dom';
import { Container, Card, Row, Col, Button, Dropdown, Form } from 'react-bootstrap';
import JobSeekerNavbar from '../../../../Pages/Navbar/JobSeekerNavbar';
import Swal from 'sweetalert2';
import BaseUrl from '../../../../ApiServices/BaseUrl';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const JobPreference = () => {
  const location = useLocation();
  const { userId, userName, current_country, job_position } = location.state || {};

  // Log userId to console
  useEffect(() => {
    console.log('Received userId:', userId);
    console.log('Received userName:', userName);
    console.log('Received current_country:', current_country);
    console.log('Received job_position:', job_position);
  }, [userId, current_country, job_position]);

  // State for preferred countries (multiple selection)
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [otherCountry, setOtherCountry] = useState('');

  // State for language skills
  const [selectedLanguages, setSelectedLanguages] = useState([]);

  // State for doctor licenses
  const [doctorLicenses, setDoctorLicenses] = useState([]);
  const [otherDoctorLicense, setOtherDoctorLicense] = useState('');
  const [doctorIssueDate, setDoctorIssueDate] = useState(null);
  const [doctorExpiryDate, setDoctorExpiryDate] = useState(null);
  const [noDoctorLicense, setNoDoctorLicense] = useState(false);

  // State for driving licenses
  const [drivingLicenses, setDrivingLicenses] = useState([]);
  const [otherDrivingLicense, setOtherDrivingLicense] = useState('');
  const [noDrivingLicense, setNoDrivingLicense] = useState(false);

  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // Selected button style
  const selectedButtonStyle = {
    backgroundColor: '#0d6efd',
    color: 'white',
    borderColor: '#0d47a1'
  };

  // Preferred country options - All world countries
  const preferredCountries = [
    // First 8 countries for button display (2 rows)
    'Qatar', 'Dubai', 'Bahrain', 'Saudi',
    'Germany', 'UK', 'Ireland', 'Canada',

    // Rest of world countries (alphabetical)
    'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola',
    'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia',
    'Austria', 'Azerbaijan', 'Bahamas', 'Bangladesh', 'Barbados',
    'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia',
    'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei',
    'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde',
    'Cambodia', 'Cameroon', 'Canada', 'Central African Republic',
    'Chad', 'Chile', 'China', 'Colombia', 'Comoros',
    'Congo (Congo-Brazzaville)', 'Costa Rica', 'Croatia',
    'Cuba', 'Cyprus', 'Czech Republic (Czechia)',
    'Democratic Republic of the Congo', 'Denmark', 'Djibouti',
    'Dominica', 'Dominican Republic', 'East Timor (Timor-Leste)',
    'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea',
    'Eritrea', 'Estonia', 'Eswatini (fmr. Swaziland)',
    'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
    'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece',
    'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau',
    'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland',
    'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland',
    'Israel', 'Italy', 'Ivory Coast', 'Jamaica', 'Japan',
    'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North',
    'Korea, South', 'Kosovo', 'Kuwait', 'Kyrgyzstan',
    'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia',
    'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
    'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali',
    'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius',
    'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia',
    'Montenegro', 'Morocco', 'Mozambique', 'Myanmar (Burma)',
    'Namibia', 'Nauru', 'Nepal', 'Netherlands',
    'New Zealand', 'Nicaragua', 'Niger', 'Nigeria',
    'North Macedonia', 'Norway', 'Oman', 'Pakistan',
    'Palau', 'Palestine', 'Panama', 'Papua New Guinea',
    'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal',
    'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis',
    'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa',
    'San Marino', 'Sao Tome and Principe', 'Saudi Arabia',
    'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone',
    'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands',
    'Somalia', 'South Africa', 'South Korea', 'South Sudan',
    'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden',
    'Switzerland', 'Syria', 'Taiwan', 'Tajikistan',
    'Tanzania', 'Thailand', 'Togo', 'Tonga',
    'Trinidad and Tobago', 'Tunisia', 'Turkey',
    'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine',
    'United Arab Emirates (UAE)', 'United Kingdom (UK)',
    'United States of America (USA)', 'Uruguay', 'Uzbekistan',
    'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
    'Yemen', 'Zambia', 'Zimbabwe', 'Any Country'
  ];
  // Language options
  const languages = [
    'English', 'Arabic', 'Nepali', 'Srilankan',
    'Thai', 'Macanese', 'India', 'Japanese',
    'Russian', 'Bangali', 'Cantonese', 'Vietnamese',
    'Mandarin', 'Combodian', 'Iranian', 'Korean',
    'Indonesia (Bahasa)', 'Filipino (Tagalog)', 'African', 'Other'
  ];

  // Doctor license countries
  const doctorLicenseCountries = [
    "Not Licensed", 'Qatar', 'Oman', 'Saudi', 'Dubai',
    'Bahrain', 'Kuwait', 'Singapore', 'Malaysia',
    'Hong Kong', 'Korea', 'Japan', 'India',
    'United Kingdom', 'United State', 'Australia', 'Canada',
    'Ireland', 'Germany', 'France', 'Philippines'
  ];

  // Driving license countries
  const drivingLicenseCountries = [
    "Not Licensed", "Qatar", "Dubai", "Oman", "Saudi", "Kuwait", "Bahrain", "EU Driving Licence", "Singapore",
    "UAE", "Turkey", "Malaysia", "Taiwan", "South Korea", "Hongkong", "Russia",
    "Jordan", "Israel", "USA", "UK", "Canada", "Australia", "India", "Philippines",
    "Saudi Arabia", "Brunei", "Hong Kong", "Japan", "Germany", "Netherlands",
    "United Kingdom", "Italy", "Spain", "France", "Poland", "Portugal", "Romania",
    "Hungary", "United States", "New Zealand", "Bangladesh", "Nepal", "Sri Lanka",
    "Pakistan", "Indonesia", "Myanmar", "Vietnam", "Cambodia", "Thailand",
    "Ethiopia", "Kenya", "Uganda", "Tanzania", "Rwanda", "Ghana", "Nigeria",
    "Sierra Leone", "Burundi", "Cameroon", "Maldives",
    "Home Country Licence", "International Driving Permit"
];

  // Helper function to filter options for dropdown
  const filterOptions = (options, searchTerm) => {
    if (!searchTerm) return options;
    return options.filter(option =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    );
  };

  // Custom Dropdown Component
  const CustomDropdown = ({
    title,
    field,
    options,
    selectedValue,
    onSelect,
    required = false,
    menuClassName = '',
    disabled = false
  }) => {
    const [localSearchTerm, setLocalSearchTerm] = useState('');
    const [isOpen, setIsOpen] = useState(false);

    const filteredOptions = filterOptions(options, localSearchTerm);

    return (
      <div>
        <Dropdown
          className="mb-3"
          show={isOpen}
          onToggle={(isOpen) => setIsOpen(isOpen)}
          disabled={disabled}
        >
          <Dropdown.Toggle
            variant="light"
            className="language-select w-100 d-flex justify-content-between align-items-center"
            id={`dropdown-${field}`}
            disabled={disabled}
          >
            {selectedValue || `${title}${required ? ' *' : ''}`}
          </Dropdown.Toggle>
          <Dropdown.Menu className={`w-100 ${menuClassName}`}>
            <div className="px-2 py-1">
              <Form.Control
                type="text"
                placeholder={`Search ${title.toLowerCase()}...`}
                value={localSearchTerm}
                onChange={(e) => setLocalSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                className="mb-2"
                autoFocus
              />
            </div>
            <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
              {filteredOptions.length > 0 ? (
                filteredOptions.map((option) => (
                  <Dropdown.Item
                    key={option}
                    active={selectedValue === option}
                    onClick={() => {
                      onSelect(field, option);
                      setLocalSearchTerm('');
                      setIsOpen(false);
                    }}
                  >
                    {option}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matches found</Dropdown.Item>
              )}
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  };

  // Fetch existing data
  useEffect(() => {
    const fetchJobPreferenceData = async () => {
      if (!userId) return;

      try {
        setIsLoading(true);
        const response = await fetch(`${BaseUrl}/api/job-seeker/doctor/${userId}`);

        if (response.ok) {
          const data = await response.json();
          console.log('Fetched data:', data);

          // Set preferred countries
          if (data.dtr_preferred_country) {
            try {
              const parsedCountries = JSON.parse(data.dtr_preferred_country);
              if (Array.isArray(parsedCountries)) {
                setSelectedCountries(parsedCountries);
              }
            } catch (e) {
              console.error('Error parsing preferred countries:', e);
            }
          }

          // Set language skills
          if (data.dtr_language_skilled) {
            try {
              const parsedLanguages = JSON.parse(data.dtr_language_skilled);
              if (Array.isArray(parsedLanguages)) {
                setSelectedLanguages(parsedLanguages);
              }
            } catch (e) {
              console.error('Error parsing languages:', e);
            }
          }

          // Set doctor licenses
          if (data.dtr_country_doctor_license) {
            try {
              const parsedDoctorLicenses = JSON.parse(data.dtr_country_doctor_license);
              if (Array.isArray(parsedDoctorLicenses) && parsedDoctorLicenses.length > 0) {
                const licenseCountries = parsedDoctorLicenses.map(license => license.country_name);
                setDoctorLicenses(licenseCountries);

                // Set dates from the first license (assuming all have same dates)
                if (parsedDoctorLicenses[0].license_issue_date) {
                  setDoctorIssueDate(new Date(parsedDoctorLicenses[0].license_issue_date));
                }
                if (parsedDoctorLicenses[0].license_expiry_date) {
                  setDoctorExpiryDate(new Date(parsedDoctorLicenses[0].license_expiry_date));
                }
              } else {
                setNoDoctorLicense(true);
              }
            } catch (e) {
              console.error('Error parsing doctor licenses:', e);
            }
          } else {
            setNoDoctorLicense(true);
          }

          // Set driving licenses
          if (data.dtr_driving_license_country) {
            try {
              const parsedDrivingLicenses = JSON.parse(data.dtr_driving_license_country);
              if (Array.isArray(parsedDrivingLicenses)) {
                setDrivingLicenses(parsedDrivingLicenses);
              }
            } catch (e) {
              console.error('Error parsing driving licenses:', e);
            }
          } else {
            setNoDrivingLicense(true);
          }
        } else if (response.status !== 404) {
          throw new Error('Failed to fetch job preference data');
        }
      } catch (err) {
        console.error('Error fetching job preference data:', err);
        Swal.fire({
          title: 'Error!',
          text: 'Failed to load your preferences. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
          confirmButtonColor: '#d33',
        });
      } finally {
        setIsLoading(false);
      }
    };

    if (userId) {
      fetchJobPreferenceData();
    }
  }, [userId]);

  // Preferred country selection handler
  const handleCountryToggle = (country) => {
    if (selectedCountries.includes(country)) {
      setSelectedCountries(selectedCountries.filter(c => c !== country));
    } else {
      if (selectedCountries.length < 4) {
        setSelectedCountries([...selectedCountries, country]);
      }
    }
  };

  // Language selection handler
  const handleLanguageToggle = (language) => {
    if (selectedLanguages.includes(language)) {
      setSelectedLanguages(selectedLanguages.filter(l => l !== language));
    } else {
      setSelectedLanguages([...selectedLanguages, language]);
    }
  };

  // Doctor license selection handler
  const handleDoctorLicenseToggle = (country) => {
    if (country === "Not Licensed") {
      setDoctorLicenses(["Not Licensed"]);
      setOtherDoctorLicense('');
      setDoctorIssueDate('');
      setDoctorExpiryDate('');
      return;
    }
    
    let updatedLicenses = doctorLicenses.filter(c => c !== "Not Licensed");
    if (updatedLicenses.includes(country)) {
      setDoctorLicenses(updatedLicenses.filter(c => c !== country));
    } else {
      setDoctorLicenses([...updatedLicenses, country]);
    }
  };

  // Driving license selection handler
  const handleDrivingLicenseToggle = (country) => {
    if (country === "Not Licensed") {
      setDrivingLicenses(["Not Licensed"]);
      setOtherDrivingLicense('');
      return;
    }

    let updatedLicenses = drivingLicenses.filter(c => c !== "Not Licensed");
    if (updatedLicenses.includes(country)) {
      setDrivingLicenses(updatedLicenses.filter(c => c !== country));
    } else {
      setDrivingLicenses([...updatedLicenses, country]);
    }
  };

  // Remove selected country
  const removeSelectedCountry = (country) => {
    setSelectedCountries(selectedCountries.filter(c => c !== country));
  };

  // Remove selected language
  const removeSelectedLanguage = (language) => {
    setSelectedLanguages(selectedLanguages.filter(l => l !== language));
  };

  // Remove selected doctor license
  const removeDoctorLicense = (country) => {
    setDoctorLicenses(doctorLicenses.filter(c => c !== country));
  };

  // Remove selected driving license
  const removeDrivingLicense = (country) => {
    setDrivingLicenses(drivingLicenses.filter(c => c !== country));
  };

  // Handle form submission to save data
  const handleSave = async () => {
    if (!userId) {
      Swal.fire({
        title: 'Error!',
        text: 'User ID is missing. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
      return;
    }

    setIsSaving(true);

    try {
      // Prepare doctor license data
      const doctorLicenseData = [];
      if (doctorLicenses.length > 0 && !noDoctorLicense) {
        doctorLicenses.forEach(country => {
          doctorLicenseData.push({
            country_name: country,
            license_issue_date: doctorIssueDate,
            license_expiry_date: doctorExpiryDate
          });
        });
      }

      // Add other doctor license if provided
      if (otherDoctorLicense && doctorIssueDate && doctorExpiryDate && !noDoctorLicense) {
        doctorLicenseData.push({
          country_name: otherDoctorLicense,
          license_issue_date: doctorIssueDate,
          license_expiry_date: doctorExpiryDate
        });
      }

      // Prepare the data object for API
      const formData = {
        user_id: userId,
        dtr_user_id: userId,
        dtr_user_name: userName,
        dtr_preferred_country: [...selectedCountries, ...(otherCountry ? [otherCountry] : [])],
        dtr_language_skilled: selectedLanguages,
        dtr_country_doctor_license: noDoctorLicense ? [] : doctorLicenseData,
        dtr_driving_license_country: noDrivingLicense ? [] : [...drivingLicenses, ...(otherDrivingLicense ? [otherDrivingLicense] : [])],
        dtr_medical_job_position: job_position || "",
        dtr_current_country: current_country || ""
      };

      console.log('Saving data:', formData);

      const response = await fetch(`${BaseUrl}/api/job-seeker/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        Swal.fire({
          title: 'Success!',
          text: 'Data saved successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
          confirmButtonColor: '#3085d6',
        });
        console.log('API Response:', result);
      } else {
        throw new Error('Failed to save data');
      }
    } catch (error) {
      console.error('Error saving data:', error);
      Swal.fire({
        title: 'Error!',
        text: 'Error saving data. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
        confirmButtonColor: '#d33',
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleBack = () => {
    navigate("/professionalinfo");
  };

  // Handle next step
  const handleNext = () => {
    handleSave();
    navigate('/professionalinformation', {
      state: { userId: userId }
    });
  };

  if (isLoading) {
    return (
      <>
        <JobSeekerNavbar />
        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <JobSeekerNavbar />
      <div className="jobpreference-wrapper" style={{ marginTop: "84px", width: '96%', marginLeft: '2%' }}>
        <Container className="mt-4 px-4 pb-5">
          <Card className="shadow border-0 professional-info-card">
            <Card.Header className="professional-info-header">
              <h2 className="m-0 text-white text-center">
                <i className="bi bi-person-badge me-2"></i>
                Job Preference
              </h2>
            </Card.Header>
            <Card.Body className="professional-info-body">

              {/* Preferred Country Section */}
              <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">What is your preferred country for a job?</h4>

                {/* Display selected countries like in the image */}
                {selectedCountries.length > 0 && (
                  <div className="mb-3">
                    <div className="selected-locations-container p-3 bg-light rounded">
                      <h6 className="mb-2 fw-semibold">Selected Locations:</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {selectedCountries.map((country, index) => (
                          <div key={index} className="selected-location-badge d-flex align-items-center bg-white border rounded-pill px-3 py-1">
                            <span className="me-2">{country}</span>
                            <button
                              type="button"
                              className="btn-close btn-close-sm"
                              aria-label="Close"
                              onClick={() => removeSelectedCountry(country)}
                              style={{ fontSize: '0.5rem' }}
                            ></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Display first 4 countries as buttons - 2 per row on mobile (xs-6), 4 per row on large (lg-3) */}
                <Row className="g-3 mb-3">
                  {preferredCountries.slice(0, 8).map((country, idx) => (
                    <Col xs={6} lg={3} key={idx}>
                      <Button
                        className={`language-btn jobtype-btn w-100 ${selectedCountries.includes(country) ? 'selected-button' : ''}`}
                        onClick={() => handleCountryToggle(country)}
                        disabled={selectedCountries.length >= 8 && !selectedCountries.includes(country)}
                      >
                        {country}
                      </Button>
                    </Col>
                  ))}
                </Row>

                {/* Dropdown for remaining countries */}
                {preferredCountries.length > 8 && (
                  <div className="mb-3">
                    <CustomDropdown
                      title="Select other preferred country"
                      field="preferred_country_dropdown"
                      options={preferredCountries.slice(8)}
                      selectedValue={selectedCountries.find(country =>
                        preferredCountries.slice(8).includes(country)
                      ) || ""}
                      onSelect={(field, country) => {
                        handleCountryToggle(country);
                      }}
                      required={false}
                      menuClassName="personalinfo-nationality-menu"
                    />
                  </div>
                )}

                <div className="text-center">
                  <p className="mt-2 fw-semibold jobpreference-select-maximum text-start">
                    Maximum 4 country you can select
                  </p>
                  <div className="mt-2">
                    <small className="jobpreference-note-text text-start">
                      {/* Selected: {selectedCountries.length}/4 */}
                    </small>
                  </div>
                </div>

                <hr className="my-4" />

                <div className="d-flex align-items-center">
                  {/* <span className="me-2">OR</span> */}
                  <div className="jobpreference-dropdown-wrapper flex-grow-1">
                    <select
                      className="jobpreference-select form-select"
                      value={otherCountry}
                      onChange={(e) => setOtherCountry(e.target.value)}
                    >
                      <option value="">Select here if any other country</option>
                      {preferredCountries.map((country, index) => (
                        <option key={index} value={country}>{country}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {/* Language Skills Section */}
              <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Language Skilled (Select)</h4>

                {/* Display selected languages like in the image */}
                {selectedLanguages.length > 0 && (
                  <div className="mb-3">
                    <div className="selected-locations-container p-3 bg-light rounded">
                      <h6 className="mb-2 fw-semibold">Selected Languages:</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {selectedLanguages.map((language, index) => (
                          <div key={index} className="selected-location-badge d-flex align-items-center bg-white border rounded-pill px-3 py-1">
                            <span className="me-2">{language}</span>
                            <button
                              type="button"
                              className="btn-close btn-close-sm"
                              aria-label="Close"
                              onClick={() => removeSelectedLanguage(language)}
                              style={{ fontSize: '0.5rem' }}
                            ></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Display first 4 languages as buttons - 2 per row on mobile (xs-6), 4 per row on large (lg-3) */}
                <Row className="g-3 mb-3">
                  {languages.slice(0, 4).map((language, idx) => (
                    <Col xs={6} lg={3} key={idx}>
                      <Button
                        className={`language-btn jobtype-btn w-100 ${selectedLanguages.includes(language) ? 'selected-button' : ''}`}
                        onClick={() => handleLanguageToggle(language)}
                      >
                        {language}
                      </Button>
                    </Col>
                  ))}
                </Row>

                {/* Dropdown for remaining languages */}
                {languages.length > 4 && (
                  <div className="mb-3">
                    <CustomDropdown
                      title="Select other language"
                      field="language_dropdown"
                      options={languages.slice(4)}
                      selectedValue={selectedLanguages.find(language =>
                        languages.slice(4).includes(language)
                      ) || ""}
                      onSelect={(field, language) => {
                        handleLanguageToggle(language);
                      }}
                      required={false}
                      menuClassName="personalinfo-nationality-menu"
                    />
                  </div>
                )}
              </div>

              {/* Doctor License Section */}
              <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Which Country Doctor License do you have?</h4>

                {/* Display selected doctor licenses like in the image */}
                {doctorLicenses.length > 0 && (
                  <div className="mb-3">
                    <div className="selected-locations-container p-3 bg-light rounded">
                      <h6 className="mb-2 fw-semibold">Selected Doctor Licenses:</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {doctorLicenses.map((country, index) => (
                          <div key={index} className="selected-location-badge d-flex align-items-center bg-white border rounded-pill px-3 py-1">
                            <span className="me-2">{country}</span>
                            <button
                              type="button"
                              className="btn-close btn-close-sm"
                              aria-label="Close"
                              onClick={() => removeDoctorLicense(country)}
                              style={{ fontSize: '0.5rem' }}
                            ></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Display first 4 doctor license countries as buttons - 2 per row on mobile (xs-6), 4 per row on large (lg-3) */}
                <Row className="g-3 mb-3">
                  {doctorLicenseCountries.slice(0, 4).map((country, idx) => (
                    <Col xs={6} lg={3} key={idx}>
                      <Button
                        className={`language-btn jobtype-btn w-100 ${doctorLicenses.includes(country) ? 'selected-button' : ''}`}
                        onClick={() => handleDoctorLicenseToggle(country)}
                        disabled={doctorLicenses.includes("Not Licensed") && country !== "Not Licensed"}
                      >
                        {country}
                      </Button>
                    </Col>
                  ))}
                </Row>

                {/* Dropdown for remaining doctor license countries */}
                {doctorLicenseCountries.length > 4 && (
                  <div className="mb-3">
                    <CustomDropdown
                      title="Select other doctor license country"
                      field="doctor_license_dropdown"
                      options={doctorLicenseCountries.slice(4)}
                      selectedValue={doctorLicenses.find(country =>
                        doctorLicenseCountries.slice(4).includes(country)
                      ) || ""}
                      onSelect={(field, country) => {
                        handleDoctorLicenseToggle(country);
                      }}
                      required={false}
                      menuClassName="personalinfo-nationality-menu"
                      disabled={doctorLicenses.includes("Not Licensed")}
                    />
                  </div>
                )}

                {/* <hr className="my-4" /> */}

                {/* Replace this section in the Doctor License Section */}
                <div className="mb-3">
                  {/* <h6 className="mb-3 fields-headingfont">Doctor License in Other Country? (Select here)</h6> */}

                  <div className="row align-items-center">
                    <div className="col-md-4">
                      {/* CustomDropdown with label wrapper to match structure */}
                      <div className="d-flex flex-column h-100">
                        {/* <label className="form-label">Doctor License in Other Country? (Select here)</label> */}
                        <CustomDropdown
                          title="Select Country"
                          field="other_doctor_license"
                          options={doctorLicenseCountries}
                          selectedValue={otherDoctorLicense}
                          onSelect={(field, value) => {
                            if (!doctorLicenses.includes("Not Licensed")) {
                              setOtherDoctorLicense(value);
                            }
                          }}
                          required={false}
                          menuClassName="personalinfo-nationality-menu"
                          className="h-100"
                          disabled={doctorLicenses.includes("Not Licensed")}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      {/* <label className="form-label">Doctor License issue date</label> */}
                      <DatePicker
                        selected={doctorIssueDate}
                        onChange={(date) => setDoctorIssueDate(date)}
                        className="jobpreference-input form-control h-100"
                        placeholderText="Select issue date"
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={20}
                        scrollableYearDropdown
                        dateFormat="MM/dd/yyyy"
                        autoFocus={false}
                        style={{ minHeight: "38px" }}
                        disabled={doctorLicenses.includes("Not Licensed")}
                      />
                    </div>
                    <div className="col-md-4">
                      {/* <label className="form-label">Doctor License expiry date</label> */}
                      <DatePicker
                        selected={doctorExpiryDate}
                        onChange={(date) => setDoctorExpiryDate(date)}
                        className="jobpreference-input form-control h-100"
                        placeholderText="Select expiry date"
                        minDate={doctorIssueDate}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={20}
                        scrollableYearDropdown
                        dateFormat="MM/dd/yyyy"
                        autoFocus={false}
                        style={{ minHeight: "38px" }}
                        disabled={doctorLicenses.includes("Not Licensed")}
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                  {/* <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="noDoctorLicense"
                      checked={noDoctorLicense}
                      onChange={() => {
                        setNoDoctorLicense(!noDoctorLicense);
                        // When "Not Licensed" is checked, clear all selected doctor licenses
                        if (!noDoctorLicense) {
                          setDoctorLicenses([]);
                          setOtherDoctorLicense('');
                          setDoctorIssueDate('');
                          setDoctorExpiryDate('');
                        }
                      }}
                    />
                    <label className="form-check-label" htmlFor="noDoctorLicense">
                      Not Licensed
                    </label>
                  </div> */}
                </div>
              </div>

              {/* Driving License Section */}
              <div className="mb-5">
                <h4 className="mb-3 fw-semibold text-dark d-flex align-items-center fields-headingfont">Which Country Driving License you have? (Select)</h4>

                {/* Display selected driving licenses like in the image */}
                {drivingLicenses.length > 0 && (
                  <div className="mb-3">
                    <div className="selected-locations-container p-3 bg-light rounded">
                      <h6 className="mb-2 fw-semibold">Selected Driving Licenses:</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {drivingLicenses.map((country, index) => (
                          <div key={index} className="selected-location-badge d-flex align-items-center bg-white border rounded-pill px-3 py-1">
                            <span className="me-2">{country}</span>
                            <button
                              type="button"
                              className="btn-close btn-close-sm"
                              aria-label="Close"
                              onClick={() => removeDrivingLicense(country)}
                              style={{ fontSize: '0.5rem' }}
                            ></button>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {/* Display first 4 driving license countries as buttons - 2 per row on mobile (xs-6), 4 per row on large (lg-3) */}
                <Row className="g-3 mb-3">
                  {drivingLicenseCountries.slice(0, 4).map((country, idx) => (
                    <Col xs={6} lg={3} key={idx}>
                      <Button
                        className={`language-btn jobtype-btn w-100 ${drivingLicenses.includes(country) ? 'selected-button' : ''}`}
                        onClick={() => handleDrivingLicenseToggle(country)}
                        disabled={drivingLicenses.includes("Not Licensed") && country !== "Not Licensed"}
                      >
                        {country}
                      </Button>
                    </Col>
                  ))}
                </Row>

                {/* Dropdown for remaining driving license countries */}
                {drivingLicenseCountries.length > 4 && (
                  <div className="mb-3">
                    <CustomDropdown
                      title="Select other driving license country"
                      field="driving_license_dropdown"
                      options={drivingLicenseCountries.slice(4)}
                      selectedValue={drivingLicenses.find(country =>
                        drivingLicenseCountries.slice(4).includes(country)
                      ) || ""}
                      onSelect={(field, country) => {
                        handleDrivingLicenseToggle(country);
                      }}
                      required={false}
                      menuClassName="personalinfo-nationality-menu"
                      disabled={drivingLicenses.includes("Not Licensed")}
                    />
                  </div>
                )}

                <hr className="my-4" />

                <div className="d-flex align-items-center mb-3">
                  {/* <span className="me-2">OR</span> */}
                  <div className="jobpreference-dropdown-wrapper flex-grow-1">
                    <select
                      className="jobpreference-select form-select"
                      value={otherDrivingLicense}
                      onChange={(e) => setOtherDrivingLicense(e.target.value)}
                      disabled={drivingLicenses.includes("Not Licensed")}
                    >
                      <option value="">Select other driving license country</option>
                      {drivingLicenseCountries.filter(c => c !== "Not Licensed").map((country, index) => (
                        <option key={index} value={country}>{country}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-check mt-3">
                  {/* <input
                    className="form-check-input"
                    type="checkbox"
                    id="noDrivingLicense"
                    checked={noDrivingLicense}
                    onChange={() => setNoDrivingLicense(!noDrivingLicense)}
                  /> */}
                  {/* <label className="form-check-label" htmlFor="noDrivingLicense">
                    Not Licensed
                  </label> */}
                </div>
              </div>

              {/* Save and Next Buttons */}
              <div className="additional-section mb-4" style={{ marginTop: '20px' }}>
                <div className="d-flex justify-content-between gap-2" style={{ width: "100%" }}>
                  <button
                    className="nav-btn"
                    style={{ flex: 1 }}
                    onClick={handleBack}
                    disabled={isSaving}
                  >
                    Back
                  </button>

                  <button
                    className="nav-btn"
                    style={{ flex: 1 }}
                    onClick={handleSave}
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : "Save"}
                  </button>

                  <button
                    className="nav-btn"
                    style={{ flex: 1 }}
                    onClick={handleNext}
                    disabled={isSaving}
                  >
                    {isSaving ? "Saving..." : "Next"}
                  </button>
                </div>
              </div>

            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default JobPreference;
